<template>
    <div class="ContactPreference">
        <div class="preference-header">
            <div class="title">联系人偏好</div>
            <el-button @click="addPreference">添加偏好</el-button>
        </div>
        <div>
            <el-tabs v-model="activeName" style="margin-top:1vh" class="contact-preference-tab">
                <el-tab-pane label="合同" name="contract-preference">
                    <ContractPreference :contactId="contactId" :refreshId="refreshId" />
                </el-tab-pane>
                <el-tab-pane label="订单" name="project-preference">
                    <ProjectPreference :contactId="contactId" :refreshId="refreshId" />
                </el-tab-pane>
                <el-tab-pane label="结算" name="settlement-preference">
                    <SettlementPreference :contactId="contactId" :refreshId="refreshId" />
                </el-tab-pane>
            </el-tabs>
        </div>
        <ContactPreferenceDialog v-model="contactPreferenceDialogVisible" :contactName="contactName" :contactId="contactId" @refresh="refresh" />
    </div>
</template>

<script>
import ContractPreference from './ContractPreference.vue';
import ProjectPreference from './ProjectPreference.vue';
import SettlementPreference from './SettlementPreference.vue';
import ContactPreferenceDialog from './ContactPreferenceDialog.vue';
export default {
    name: "ContactPreference",
    components: {
        ContractPreference,
        ProjectPreference,
        SettlementPreference,
        ContactPreferenceDialog
    },
    props: {
        contactId: {
            required: true
        },
        contactName: {
            required: true
        },
        contactId: {
            required: true
        }
    },
    data() {
        return {
            activeName: "contract-preference",
            contactPreferenceDialogVisible: false,
            refreshId: 0
        }
    },

    methods: {
        addPreference() {
            this.contactPreferenceDialogVisible = true
        },

        refresh() {
            this.refreshId += 1
        }
    }
    

}
</script>

<style lang="scss">

  .ContactPreference{
    /* width: 80%; */
    width: 100%;
    padding: 30px;
    box-shadow: 0 0px 10px 6px #f5f5f5;
    margin-top:20px;
    min-height: 350px;
  }
  .preference-header{
    display: flex;
    justify-content:space-between;
  }
  .title{
    font-weight: bold;
    font-size:18px
  }

  .contact-preference-tab {
    .el-tabs__item {
      min-width: 50px!important;
    }
  }

</style>
